import { render } from "./CategoryTreeForm.vue?vue&type=template&id=81560878"
import script from "./CategoryTreeForm.vue?vue&type=script&lang=js"
export * from "./CategoryTreeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__